export enum FarmTypesEnum{
    OWN = 'OWN',
    OTHERS = 'OTHERS'
}